import { render } from "./Campains.vue?vue&type=template&id=69a14853&scoped=true"
import script from "./Campains.vue?vue&type=script&lang=js"
export * from "./Campains.vue?vue&type=script&lang=js"

import "./Campains.vue?vue&type=style&index=0&id=69a14853&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a14853"]])

export default __exports__